import React from 'react';

import { classes } from './RunningIcon.st.css';
import { FCWithChildren } from '@wix/challenges-web-library';

export const RunningIcon: FCWithChildren = () => {
  return (
    <div className={classes.root}>
      <span className={classes.rootCircle}></span>
    </div>
  );
};
